module.exports = __webpack_public_path__ + "img/ic_chevron_down.8da49945.svg";